/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PinIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "pin", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 10.5C6.5 7 9 4.5 12.5 4.5C16 4.5 18.5 7 18.5 10.5C18.5 14 15.5 17.5 12.5 20.5C9.5 17.5 6.5 14 6.5 10.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 12.5, cy: 10.5, r: 1.5, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(PinIcon);
export default ForwardRef;
//# sourceMappingURL=pinIcon.js.map